<template>
    <div class="order-content">
        <div class="row no-gutters justify-content-start align-items-center common-step-head order-head">
            <img
                src="../assets/images/complete_icon.png"
                alt="step"
            />
            <p>{{$t('orderInfo.title')}}</p>
        </div>
        <!-- 商品 & 订单 begin -->
        <div class="row justify-content-between no-gutters common-step-padding">
            <!-- web端 订单信息图片展示 begin -->
            <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div class="show-pc">
                    <div class="goods-info">
                        <img
                            :src="giftImage"
                            :alt="giftName"
                        />
                        <div class="good-info-mask">
                            <p>{{$t('orderInfo.desp')}}</p>
                            <span>{{giftName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- web端 订单信息图片展示 end -->
            <!-- 订单信息 begin -->
            <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8">
                <div class="left-form-distance">
                    <p class="order-title">{{$t('orderInfo.orderTitle')}}</p>
                    <div class="row no-gutters order-info order-info-bg">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <p>{{$t('orderInfo.orderId')}}</p>
                            <span>{{$store.state.amazonOrderID}}</span>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <p>{{$t('orderInfo.productASIN')}}</p>
                            <span>{{$store.state.amazonProductASIN}}</span>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <p>{{$t('orderInfo.productName')}}</p>
                            <span>{{$store.state.amazonProductName}}</span>
                        </div>
                        <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <p>{{$t('orderInfo.address')}}</p>
                            <span>Vaibhav Patel 1402 OAK MANOR CT BEL MD 21015-5853
                                US</span>
                        </div> -->
                    </div>
                    <!-- 移动端 订单信息图片展示 begin -->
                    <div class="show-phone">
                        <div class="goods-info">
                            <img
                                :src="giftImage"
                                :alt="giftName"
                            />
                            <div class="good-info-mask">
                                <p>{{$t('orderInfo.desp')}}</p>
                                <span>{{giftName}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 移动端 订单信息图片展示 end -->
                    <div class="about-text">
                        <p>{{$t('orderInfo.aboutGift[0]')}}</p>
                        <div>
                            <p>
                                {{$t('orderInfo.aboutGift[1]')}}
                            </p>
                            <p>{{$t('orderInfo.aboutGift[2]')}}</p>
                            <p>
                                {{$t('orderInfo.aboutGift[3]')}}
                            </p>
                        </div>
                    </div>
                    <div class="row no-gutters justify-content-end">
                        <button
                            type="button"
                            class="common-comfirm-btn btn-width-100"
                            @click="goNext"
                        >
                            {{$t('orderInfo.btnWant')}}
                        </button>
                    </div>
                </div>
            </div>
            <!-- 订单信息 end -->
        </div>
        <!-- 商品 & 订单 end -->
    </div>
</template>

<script>

export default {
    name: 'Order',
    data() {
        return {
            giftID: null,
            giftName: '',
            giftType: '',
            giftImage: ''
        }
    },
    components: {

    },
    mounted() {
        this.giftID = Number(this.$route.query.giftID)
        this.giftName = this.$route.query.giftName
        this.giftType = this.$route.query.giftType
        this.giftImage = this.$route.query.giftImage
    },
    methods: {
        // 确认选择礼品
        putOrderInfo() {
            let shopID = this.$store.state.shopID // 店铺id 
            let amazonOrderID = this.$store.state.amazonOrderID // 亚马逊订单id             

            this.$put(`/api/v1/shops/${shopID}/gifts/${this.giftID}`, { 'amazon_order_id': amazonOrderID }).then(data => {
                this.$store.state.giftID = this.giftID
                this.$store.state.giftName = this.giftName
                this.$store.state.giftType = this.giftType
                this.$store.state.giftImage = this.giftImage
                this.$store.state.giftOrderID = data.result.jid

                this.$router.push({ path: '/stepOne' })
            }).catch(err => {
                console.info(err)
            })
        },
        // 跳转下一步 填写问卷步骤一
        goNext() {
            this.putOrderInfo()
        }
    }
}
</script>

<style scoped>
.order-head {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #f0f0f0;
}

.order-title {
    font-size: 24px;
    font-weight: 500;
}

.order-info-bg {
    padding: 20px 15px;
    background: #f7f7f7;
    margin: 15px 0 20px 0;
}

.order-info-bg div {
    margin-bottom: 15px;
}

.order-info-bg div:last-child {
    margin-bottom: 0;
}

.order-info p {
    font-weight: 500;
}

.order-info span,
.about-text > div > p {
    color: #555555;
}

.about-text {
    margin-bottom: 20px;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .order-head {
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f0f0f0;
    }
    .order-title {
        font-size: 18px;
    }
    .about-text {
        margin-top: 15px;
    }
}
</style>